import React from "react";
import {Colors, Container, OutlinedInput, Text} from "bounce-ui/backoffice";
import {KeyValueRow} from "../Components";
import {InputAdornment} from "../../../../../../../../bounce-ui/backoffice";
import {getError} from "../utils";

interface IPlanMatrix {
  downPayment?: number;
  setDownPayment: (value: number) => void;
  editMode: boolean;
  error: any;
  setError: (value: any) => void;
  totalBalance: number;
}

const ConfigureDownPayment = ({downPayment, setDownPayment, editMode, error, setError, totalBalance}: IPlanMatrix) => {
  return (
    <KeyValueRow field={"Down payment amount"}>
      <Container row fullWidth sx={{justifyContent: "space-between"}}>
        <Text color={Colors.red._900}>{error || ""}</Text>
        <OutlinedInput
          autoFocus
          type="number"
          value={downPayment || ""}
          inputProps={{min: 25}}
          onChange={(event: any) => {
            setDownPayment(event.target.value);
            getError(event, totalBalance, setError);
          }}
          startAdornment={
            <InputAdornment position="start">
              <Text>$</Text>
            </InputAdornment>
          }
          error={!!error}
          disabled={!editMode}
          sx={{
            height: "36px",
            width: "144px",
            "& input": {
              fontWeight: 500,
              textAlign: "center",
            },
          }}
        />
      </Container>
    </KeyValueRow>
  );
};

export default ConfigureDownPayment;
